





import Vue from 'vue'
import Component from 'vue-class-component'
import querystring from 'querystring'

import SearchComponent from '../components/Search.vue'
import axios from 'axios'


@Component({
  components: {
    SearchComponent
  }
})
export default class Login extends Vue {

  certification: any = null

  loading = false

  data: { givenName?: string, surname?: string, certification?: string } = {}

  mounted() {
    this.data = {
      givenName: this.$route.query.givenName as string,
      surname: this.$route.query.surname as string,
      certification: this.$route.query.certification as string,
    }
  }

  async validate(data: { givenName: string, surname: string, certification: string }) {
    this.loading = true
    this.certification = null

    try {
      const response = await axios.get('/certificates/validate', { params: data })
      this.certification = response.data
    } catch (err) {
      this.certification = { error: true }
    } finally {
      this.loading = false
    }
  }

  retryValidation() {
    if (this.$route.query.redirect) {
      let redirect = this.$route.query.redirect as string
      location.replace(`${process.env.VUE_APP_SITE_URL}/verify-tefl-certificate-can-i-teach-abroad/`)
    } else {
      this.certification = null
    }
  }
}
